module.exports = __webpack_public_path__ + "static/media/lucky_border1.9ef0765b.png";